import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../../Components/atoms/Typography/Heading/Heading";
import { SubHeader4 } from "../../../Components/atoms/Typography/SubHeader/SubHeader";
import { MessageForm } from "../../../Components/molecules/AuthForms/MessageForm";
import { ResetPasswordUsernameForm } from "../../../Components/molecules/AuthForms/ResetPasswordUsernameForm";
import { FormItemsWrap } from "../../../Components/molecules/Wrap/Wrap";
import { useAuth } from "../../../Store/AuthContext";

export const RequestResetPassword = () => {
  const { t, i18n } = useTranslation(["glossary"]);
  //  Admin - Password reset already existing user
  const { state, dispatch } = useAuth();
  const [stepCount, setStepCount] = useState(0);
  const [showSucceed, setShowSucceed] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (state.lang.cookie && state.lang.code && stepCount === undefined) {
      setStepCount(1);
    } else if (!state.lang.cookie && stepCount === undefined) {
      const code = document.cookie
        .split(" ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1];
      if (code) {
        dispatch({
          type: "SET_LANG_FROM_COOKIE",
          payload: code,
        });

        i18n.changeLanguage(code);
        setStepCount(1);
      } else {
        setStepCount(0);
      }
    }
    dispatch({
      type: "LOADING",
      payload: false,
    });
  }, [state.lang, stepCount]);

  const steps = [
    {
      title: t("glossary:auth.reset-password.title"),
      subheading: t("glossary:auth.reset-password.subheading1"),
      component: (
        <ResetPasswordUsernameForm
          t={t}
          state={state}
          onClick={(status) => {
           
            if (status === "pass") {
              // setShowSucceed(true);
              // setStepCount(stepCount + 1);
              navigate("/signin/forgot-password-message", { state: { message: { messageLineOne: t("glossary:auth.reset-password.reset-link") } } })
            }

          }}
        />
      ),
    },
    showSucceed && {
      isNoHeading: true,
      component: (
        <MessageForm
          messageLineOne={t("glossary:auth.reset-password.reset-link")}
        />
      ),
    },
  ];

  return (
    <Stack
      style={{
        padding: steps[stepCount]?.padding || "38px",
      }}
    >
      <FormItemsWrap
        gap={"32px"}
        width={"398px"}
        alignItems={steps[stepCount]?.alignItems}
        justifyContent={"space-around"}
      >
        {!steps[stepCount]?.isNoHeading && (
          <FormItemsWrap>
            <Heading text={steps[stepCount]?.title} />
            <SubHeader4 text={steps[stepCount]?.subheading} />
          </FormItemsWrap>
        )}
        {steps[stepCount]?.component}
      </FormItemsWrap>
    </Stack>
  );
};
